// extracted by mini-css-extract-plugin
module.exports = {"continueContractPageRoot":"continueContractPageRoot--ac45e"};